import httpClient from "@/httpClient"

const getCompanyPublic = (id) => httpClient.get(`/companies/${id}/public-data`)
const getUserCompanies = (account) => httpClient.get(`/accounts/${account}/companies?config=1`)

export default {
  getCompanyPublic,
  getUserCompanies,
}
